<sc-master-detail [data]="roles" (selectionChanged)="onSelectionChanged($event)" [selection]="[selectedVisitorRole]"
  [newStyle]="true" (addEntry)="onAddEntry($event)" (deleteEntry)="onDeleteEntry($event)">

  <sc-scroll-pane>
    @if (currentVisitRole != null) {
      <div class="details-area no-field-space">
        <sc-padding>
          <form [formGroup]="formGroup">
            <sc-flex vertical stretchContent>
              <sc-dictionary-field [model]="currentVisitRole.name" (dictionaryChanged)="onDictionaryChange($event)"
                [labelDictionaryKey]="'tmc-yard.entity.transport-option.name'" [required]="true" [maxlength]="255">
              </sc-dictionary-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-string-field grow formControlName="icon" [required]="false"
                labelDictionaryKey="tmc.visit.visitor-role.icon">
              </sc-string-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-select-field formControlName="entranceByCarCategory"
                labelDictionaryKey="tmc-visit.entity.visitor-role.entranceByCarCategory"
              [data]="entranceByCarCategories"></sc-select-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field labelDictionaryKey="tmc.visit.visitor-role.allowYardEntranceByCar"
              formControlName="allowYardEntranceByCar"></sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field labelDictionaryKey="tmc.visit.visitor-role.allowYardEntranceOnFoot"
              formControlName="allowYardEntranceOnFoot"></sc-checkbox-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-checkbox-field formControlName="allowOverrideRoleSettings"
              labelDictionaryKey="tmc.visit.visitor-role.allowOverrideRoleSettings"></sc-checkbox-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-checkbox-field formControlName="invitationRequiresConfirmation"
              labelDictionaryKey="tmc.visit.visitor-role.invitationRequiresConfirmation"></sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <!-- einrückung-->
              <sc-checkbox-field formControlName="invitationConfirmationOnAccessOnly"
              labelDictionaryKey="tmc.visit.visitor-role.invitationConfirmationOnAccessOnly"></sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field formControlName="assignPrivilegesOnInvitation"
              labelDictionaryKey="tmc.visit.visitor-role.assignPrivilegesOnInvitation"></sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field labelDictionaryKey="tmc.visit.visitor-role.only-secured-access"
              formControlName="onlySecuredAccess"></sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field labelDictionaryKey="tmc.visit.visitor-role.showInTerminal"
              formControlName="showInTerminal"></sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field labelDictionaryKey="tmc.visit.visitor-role.requireTerminalLogin"
              formControlName="requireTerminalLogin"></sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-select-field formControlName="requireTerminalLoginType"
                labelDictionaryKey="tmc-visit.entity.visitor-role.requireTerminalLoginType"
              [data]="terminalLoginTypes"></sc-select-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field
                [label]="'requireInstructionsDone' | translate: ['tmc.visit.visitor-role.requireInstructionsDone', translationService.language]"
              formControlName="requireInstructionsDone"></sc-checkbox-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-checkbox-field labelDictionaryKey="tmc.visit.visitor-role.oneTimeVisit"
              formControlName="oneTimeVisit"></sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-number-field labelDictionaryKey="tmc.visit.visitor-role.validDaysCount" formControlName="validDaysCount"
                [required]="true">
              </sc-number-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-checkbox-field labelDictionaryKey="tmc.visit.visitor-role.includeRegistrationQRCodeInMail"
              formControlName="includeRegistrationQRCodeInMail"></sc-checkbox-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-number-field labelDictionaryKey="tmc.visit.visitor-role.cleanupAfterHours"
                formControlName="cleanupAfterHours" [required]="true">
              </sc-number-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-number-field labelDictionaryKey="tmc.visit.visitor-role.deleteAfterHours"
                formControlName="deleteAfterHours" [required]="true">
              </sc-number-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-text-field [grow]="true" [minRows]="5" formControlName="upfrontRegistrationMailBody" [required]="false"
                labelDictionaryKey="tmc.visit.visitor-role.upfrontRegistrationMailBody">
              </sc-text-field>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-title>
                <sc-dictionary-label
                dictionaryKey="tmc-visit.widgets.visitor-role-administration.infotexts.title"></sc-dictionary-label>
              </sc-title>
              <sc-content-spacer vertical></sc-content-spacer>
              <div class="infotexts" cdkDropList (cdkDropListDropped)="drop($event)">
                @for (infotext of currentVisitRole.informationTexts; track infotext) {
                  @if (!infotext.deleted) {
                    <div class="infotext" cdkDrag>
                      <sc-flex>
                        <sc-dictionary-text-field [model]="infotext.text" (dictionaryChanged)="onDictionaryChange($event)"
                          [labelDictionaryKey]="'tmc-visit.entity.visitor-role-infotext.text'" [required]="true"
                          style="width: 500px;">
                        </sc-dictionary-text-field>
                        <sc-content-spacer [vertical]="false"></sc-content-spacer>
                        <div class="delete-button">
                          <sc-icon iconClass="fa-trash" (click)="removeInfotext(infotext)"></sc-icon>
                        </div>
                      </sc-flex>
                    </div>
                  }
                  <sc-content-spacer vertical></sc-content-spacer>
                }
                <sc-flex centered>
                  <sc-action-icon iconClass="fa-plus fa-2x" (click)="addInfotext()"></sc-action-icon>
                </sc-flex>
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-title>
                  <sc-dictionary-label dictionaryKey="tmc-visit.ui.visitor-role.tasks"></sc-dictionary-label>
                </sc-title>
                <sc-content-spacer vertical></sc-content-spacer>
                @for (task of currentVisitRole.tasks; track task) {
                  <div class="task" [ngClass]="{'deleted': task.deleted}">
                    <sc-padding>
                      <sc-flex>
                        <div>{{task.name.getValue(translationService.language)?.value}}</div>
                        <sc-content-spacer></sc-content-spacer>
                        <div>
                          {{task.validity}} / @if (task.optional) {
                          <sc-dictionary-label
                          dictionaryKey="tmc.visit.visitor-role.task-optional"></sc-dictionary-label>
                          }@if (!task.optional) {
                          <sc-dictionary-label
                          dictionaryKey="tmc.visit.visitor-role.task-not-optional"></sc-dictionary-label>
                        }
                      </div>
                      <sc-content-spacer grow></sc-content-spacer>
                      <sc-action-icon iconClass="fa-pencil" (click)="editTask(task)"></sc-action-icon>
                      <sc-content-spacer></sc-content-spacer>
                      @if (!task.deleted) {
                        <sc-action-icon iconClass="fa-trash" (click)="markDeleted(task)"
                        ></sc-action-icon>
                      }
                      @if (task.deleted) {
                        <sc-action-icon iconClass="fa-trash-slash" (click)="unmarkDeleted(task)"
                        ></sc-action-icon>
                      }
                    </sc-flex>
                  </sc-padding>
                </div>
                <sc-content-spacer vertical></sc-content-spacer>
              }
              <sc-flex centered>
                <sc-action-icon iconClass="fa-plus fa-2x" (click)="addTask()"></sc-action-icon>
              </sc-flex>
            </div>
          </sc-flex>
        </form>
      </sc-padding>
    </div>
  }

</sc-scroll-pane>

<ng-template masterDetailToolbar>
  <sc-cancel-button class="config-changed-button" (click)="cancel()" [disabled]="!formGroup.dirty"></sc-cancel-button>
  <sc-content-spacer></sc-content-spacer>
  <sc-save-button primary class="config-changed-button" (click)="save()"
  [disabled]="!formGroup.dirty || !formGroup.valid"></sc-save-button>
</ng-template>

</sc-master-detail>
